<template>
	<div style="display: contents">
		<div class="is-hidden-mobile navbar-item notifications-button-item" :class="{'is-active' : this.notificationslist}">	
			<div class="buttons">
				<div class="dropdown" :class="{'is-active' : this.notificationslist}">
					<div class="dropdown-trigger">
						<a href="" class="notifications-icon is-relative" @click.prevent="toogleNotifications">
							<span aria-hidden="true"></span>
							<font-awesome-icon icon="bell" size="lg" />
							<span v-if="this.notifications == null && this.user.user.notificaciones_count > 0" class="tag is-danger">{{ this.user.user.notificaciones_count }}</span>
							<span v-if="this.notifications != null && unreadNotifications > 0" class="tag is-danger">{{ unreadNotifications }}</span>
						</a>
					</div>
					<div class="dropdown-menu notificaciones-menu">
						<ListaNotificaciones v-if="notificationslist" :showLoading="true" :visible="notificationslist" v-on:clickItem="toogleNotifications" />
					</div>
				</div>
			</div>
		</div>
		<div class="is-hidden-tablet navbar-item notifications-button-item" :class="{'is-active' : this.$route.fullPath.includes('notificaciones')}">
			<router-link to="/notificaciones" class="notifications-icon is-relative">
				<span aria-hidden="true"></span>
				<font-awesome-icon icon="bell" size="lg" />
				<span v-if="this.notifications == null && this.user.user.notificaciones_count > 0" class="tag is-danger">{{ this.user.user.notificaciones_count }}</span>
				<span v-if="this.notifications != null && unreadNotifications > 0" class="tag is-danger">{{ unreadNotifications }}</span>
			</router-link>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import ListaNotificaciones from '@/components/ListaNotificaciones'

	export default {
		components: { ListaNotificaciones },
		name: 'NotificationsButton',

		data() {
			return {
				notificationslist: false
			};
		},
		computed: {
			...mapState('notification',['notifications']),
			...mapState('user',['user']),
			unreadNotifications(){
				return this.notifications.filter(notification => notification.read_at == null).length
			}
		},
		watch: {

		},
		methods: {
			toogleNotifications(){

				if (this.notificationslist == true) {
					this.notificationslist = false
				}else{
					this.notificationslist = true
				}
			}
		}
	};
</script>

<style lang="css" scoped>
</style>
